import React from 'react';

type ErrorBoundaryProps = {
  name?: string;
  children?: React.ReactNode;
}

interface ErrorState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorState> {
  state: ErrorState = {
    hasError: false,
    error: null
  };

  static getDerivedStateFromError(error: Error): ErrorState {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Render error caught:', {
      error,
      errorInfo
    });
  }

  render(): React.ReactNode {
    const { hasError, error } = this.state;
    const { children, name } = this.props;

    if (hasError) {
      return (
        <div className="error-message overflow-x-auto whitespace-pre-wrap">
          <h2>{name && `[${name}]`}You have faced an issue on this web site</h2><br/>
          <h3>Name:</h3>
          <p>{error?.name && <pre>{error.name || 'no name'}</pre>}</p><br/>
          <h3>Message:</h3>
          <p>{error?.message || 'An unexpected error occurred'}</p><br/>
          <h3>Stack:</h3>
          <p>{error?.stack && <pre>{error.stack || 'stack empty'}</pre>}</p><br/>
        </div>
      );
    }

    return children || <div>No content provided</div>;
  }
}

export default ErrorBoundary;
